import React, { useState } from "react";
import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Collapse,
  useTheme,
  useMediaQuery
} from "@mui/material";

import DashboardIcon from "@mui/icons-material/Dashboard";
import CalculateIcon from "@mui/icons-material/Calculate";
import SettingsIcon from "@mui/icons-material/Settings";
import PeopleIcon from "@mui/icons-material/People";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { useNavigate, useLocation } from "react-router-dom";
import Logo from "./assets/logo2.png";

const drawerWidth = 240;

/* 🎨 SAVY & SONS THEME (FROM IMAGE) */
const COLORS = {
  sidebarBg: "#FFF6E8",
  sidebarGradient: "radial-gradient(circle at top, #FFFDF8, #FFF2DD)",
  textPrimary: "#1A1A1A",
  textSecondary: "#6B5E4A",
  accent: "#F3C26B",
  hoverBg: "#FFEFC4",
  activeBorder: "#F3C26B",
  divider: "#EADFCB"
};

const Sidebar = ({ mobileOpen, handleDrawerToggle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [openSettings, setOpenSettings] = useState(false);

   const roles = JSON.parse(sessionStorage.getItem("roles") || "[]");
const isAdmin = roles.includes("ROLE_ADMIN");

  const isActive = (path) => location.pathname === path;

  const menuItemStyle = (path) => ({
    color: COLORS.textPrimary,
    borderLeft: isActive(path)
      ? `4px solid ${COLORS.activeBorder}`
      : "4px solid transparent",
    "&:hover": {
      backgroundColor: COLORS.hoverBg
    },
    px: 2.5
  });

  const drawerContent = (
    <Box
      sx={{
        height: "100%",
        background: COLORS.sidebarGradient,
        borderRight: `1px solid ${COLORS.divider}`
      }}
    >
      {/* LOGO */}
      <Toolbar sx={{ justifyContent: "center", py: 3 }}>
        <Box
          component="img"
          src={Logo}
          alt="Savy & Sons"
          sx={{
            width: "75%",
            // backgroundColor: "#fff",
            borderRadius: 2,
            p: 1.2,
            // boxShadow: "0 8px 24px rgba(0,0,0,0.08)"
          }}
        />
      </Toolbar>

      <List>
        {/* DASHBOARD */}
        <ListItemButton
          sx={menuItemStyle("/dashboard")}
          onClick={() => navigate("/dashboard")}
        >
          <ListItemIcon
            sx={{
              color: isActive("/dashboard")
                ? COLORS.accent
                : COLORS.textSecondary
            }}
          >
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItemButton>

        {/* CALCULATORS */}
        <ListItemButton
          sx={menuItemStyle("/submissions")}
          onClick={() => navigate("/submissions")}
        >
          <ListItemIcon
            sx={{
              color: isActive("/submissions")
                ? COLORS.accent
                : COLORS.textSecondary
            }}
          >
            <CalculateIcon />
          </ListItemIcon>
          <ListItemText primary="Submissions" />
        </ListItemButton>

{isAdmin && (
  <>
        {/* SETTINGS */}
        <ListItemButton
          onClick={() => setOpenSettings(!openSettings)}
          sx={{
            color: COLORS.textPrimary,
            "&:hover": { backgroundColor: COLORS.hoverBg },
            px: 2.5
          }}
        >
          <ListItemIcon sx={{ color: COLORS.textSecondary }}>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary="Settings" />
          <ExpandMoreIcon
            sx={{
              color: COLORS.textSecondary,
              transform: openSettings ? "rotate(180deg)" : "rotate(0)",
              transition: "0.3s"
            }}
          />
        </ListItemButton>
        </>
)}
{isAdmin && (
  <>
        {/* USERS */}
        <Collapse in={openSettings} timeout="auto" unmountOnExit>
          <List disablePadding>
            <ListItemButton
              sx={{
                ...menuItemStyle("/settings/add-user"),
                pl: 6
              }}
              onClick={() => navigate("/settings/add-user")}
            >
              <ListItemIcon
                sx={{
                  color: isActive("/settings/add-user")
                    ? COLORS.accent
                    : COLORS.textSecondary
                }}
              >
                <PeopleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Add User" />
            </ListItemButton>
          </List>
          
        </Collapse>
        </>)}
      </List>
    </Box>
  );

  return (
    <Box component="nav" sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}>
      {/* MOBILE */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box"
          }
        }}
      >
        {drawerContent}
      </Drawer>

      {/* DESKTOP */}
      <Drawer
        variant="permanent"
        open
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box"
          }
        }}
      >
        {drawerContent}
      </Drawer>
    </Box>
  );
};

export default Sidebar;
